import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const LOGIN_ERROR_MESSAGES = {
  domain: 'Only @printo.in Google accounts can sign in.',
  state: 'Sign-in session expired - please try again.',
  token: 'Google sign-in failed - please try again.',
  verify: 'Could not verify your Google account - please try again.',
  '1': 'Sign-in was cancelled or failed.',
};

function GoogleLogo() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" />
      <path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.347 2.827.957 4.042l3.007-2.332z" />
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" />
    </svg>
  );
}

function SignInScreen() {
  const params = new URLSearchParams(window.location.search);
  const errorCode = params.get('login_error');
  const errorMessage = errorCode ? (LOGIN_ERROR_MESSAGES[errorCode] || 'Sign-in failed - please try again.') : null;

  return (
    <div className="uca-signin-page">
      <div className="uca-signin-card">
        <div className="uca-signin-mark">🎨</div>
        <h1 className="uca-signin-title">Category AI</h1>
        <p className="uca-signin-tagline">
          AI-classified use cases &amp; business categories for every Printo.in print order.
        </p>

        {errorMessage && (
          <div className="uca-signin-error">{errorMessage}</div>
        )}

        <a href={`${API_BASE}/auth/login`} className="uca-google-btn">
          <GoogleLogo />
          <span>Sign in with Google</span>
        </a>

        <div className="uca-signin-footer">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M8 11V7a4 4 0 018 0v4" stroke="currentColor" strokeWidth="2" />
          </svg>
          Restricted to <strong>@printo.in</strong> Google Workspace accounts
        </div>
      </div>
    </div>
  );
}

function AuthGate({ children }) {
  const [status, setStatus] = useState('loading'); // loading | authed | anon
  const [user, setUser] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE}/auth/me`, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
        setStatus('authed');
      })
      .catch(() => setStatus('anon'));
  }, []);

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="loader"></span>
      </div>
    );
  }

  if (status === 'anon') {
    return <SignInScreen />;
  }

  return children(user);
}

export default AuthGate;
